/**
 * Number of history entries that existed when the app first booted. Captured
 * once at module load (imported from `main.tsx` before render), so it reflects
 * the entry point — a fresh tab (1), or an external referrer like Google (2).
 *
 * `window.history.length` never shrinks, so if it has grown past this entry
 * count the user has pushed at least one in-app entry and "back" stays inside
 * the app. If it hasn't grown, "back" would leave the app (or there's nothing
 * behind us), and callers should route to a safe in-app fallback instead.
 */
export const APP_ENTRY_HISTORY_LENGTH =
  typeof window !== "undefined" ? window.history.length : 0;

/** True when going back would land on an in-app page rather than leaving the app. */
export function hasInAppHistory(): boolean {
  return typeof window !== "undefined" && window.history.length > APP_ENTRY_HISTORY_LENGTH;
}
